<template>
    <div>
        <menu-packetgrup />
        <menu-consumibles />
        <menu-maquinaria />
        <menu-ecoproductes />
        <menu-contacte />
    </div>
</template>

<script>
import MenuPacketgrup from './MenuPacketgrup.vue';
import MenuConsumibles from './MenuConsumibles.vue';
import MenuMaquinaria from './MenuMaquinaria.vue';
import MenuEcoproductes from './MenuEcoproductes.vue';
import MenuContacte from './MenuContacte.vue';

export default {
    name: 'MenuPrincipal',
    components: {
        MenuPacketgrup,
        MenuConsumibles,
        MenuMaquinaria,
        MenuEcoproductes,
        MenuContacte,
    },
    methods: {
        triggerClick: function (route){
        this.$router.push(route);
        }
    },
    computed: {
        rutas () {
            return this.$router.options.routes;
        },
        menu () {
            return this.$store.state.menu
        }
    }
    
}
</script>


<style scoped lang="scss">

  .icon-submenu {
    margin-right: 5px !important;
    padding-right: 0 !important;
    width: 20px !important;
    font-size: 20px !important;
  }

</style>